import { get, size } from "lodash";
import type { RootState } from "types/state";

import { getLinkedEmployersSelector } from "store/selectors/employerLink";

export const contributionAbilitySelector = (state: RootState) => {
  // user slice is still untyped (converts with the user domain batch)
  return get(state, "user.contributionAbility");
};

export const recurringContributionSelector = (state: RootState) => {
  const bankAccounts = get(state, "accounts.bankAccounts", []);
  const recurringContributions = bankAccounts.map((bankAccount) => {
    return get(bankAccount, "recurringContribution");
  });
  return size(recurringContributions) > 0 ? recurringContributions[0] : null;
};

export const payrollContributionSelector = (state: RootState) => {
  const employerLink = getLinkedEmployersSelector(state);
  // we only support one employer link right now, safe to grab first one
  const contribution = get(employerLink, "0.contribution");
  return contribution;
};
